"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const address_1 = __importDefault(require("../../address"));
const remoteImage_1 = __importDefault(require("../remoteImage"));
class PortalInvoiceConfig {
    constructor(logo, billingContact, mailTo, ach, express) {
        this.logo = logo;
        this.billingContact = billingContact;
        this.mailTo = mailTo;
        this.ach = ach;
        this.express = express;
    }
    static fromObj(data) {
        return new PortalInvoiceConfig(remoteImage_1.default.fromObj(data.logo), {
            name: data.billingContact.name,
            phone: data.billingContact.phone,
            email: data.billingContact.email
        }, {
            name: data.mailTo.name,
            address: address_1.default.fromObj(data.mailTo.address)
        }, {
            bankName: data.ach.bankName,
            aba: data.ach.aba,
            accountName: data.ach.accountName,
            accountNumber: data.ach.accountNumber
        }, {
            name: data.express.name,
            address: address_1.default.fromObj(data.express.address)
        });
    }
}
exports.default = PortalInvoiceConfig;
//# sourceMappingURL=portalInvoiceConfig.class.js.map